import { Button, Dialog, DialogContent, DialogProps, DialogTitle } from '@fortem-monorepo/react-ui'
import { DialogFooter, DialogHeader, SubmitButton } from '@fortem-monorepo/react-ui'

import { AddFundForm } from '@/components/forms/AddFundForm/AddFundForm'
import { AddFundFormFields } from '@/components/forms/AddFundForm/AddFundFormFields'

export interface AddFundModalProps extends DialogProps {}

export const AddFundModal: React.FC<AddFundModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <AddFundForm>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Add a new Fund</DialogTitle>
                </DialogHeader>
                <div className="my-6">
                  <AddFundFormFields />
                </div>
                <DialogFooter>
                  <Button
                    type="button"
                    variant={'destructive'}
                    size="sm"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </AddFundForm>
      </DialogContent>
    </Dialog>
  )
}
